import apiClient from './api';
import type { ApiResponse } from '@hyvay/shared-types';

/** A template as the catalog endpoint returns it. */
export interface Template {
    id: string;
    name: string;
    description: string;
    category: string;
    tags: string[];
    badge: string | null;
    /** Apps actually started from this template. Zero is a real answer. */
    usageCount: number;
    hasPreview: boolean;
}

const API_BASE = (import.meta.env.VITE_API_URL as string) || 'http://localhost:3000/api';

/**
 * Preview image URL.
 *
 * Built by hand instead of going through apiClient because it is used as an
 * `<img src>`, which cannot carry the bearer token — the catalog endpoints are
 * public for exactly that reason.
 */
export const templatePreviewUrl = (id: string) => `${API_BASE.replace(/\/+$/, '')}/templates/${id}/preview`;

const fail = (e: any, fallback: string) =>
    ({ success: false, message: e?.response?.data?.message || e?.message || fallback }) as any;

export const templateService = {
    async list(): Promise<ApiResponse<Template[]>> {
        try {
            return (await apiClient.get<ApiResponse<Template[]>>('/templates')).data;
        } catch (e) {
            return fail(e, 'Gagal memuat template');
        }
    },

    /** Copy a template's files into a freshly created application. */
    async apply(
        applicationId: string,
        templateId: string,
    ): Promise<ApiResponse<{ seedPrompt: string; written: number }>> {
        try {
            return (
                await apiClient.post<ApiResponse<{ seedPrompt: string; written: number }>>(
                    `/studio/applications/${applicationId}/template`,
                    { templateId },
                )
            ).data;
        } catch (e) {
            return fail(e, 'Gagal menerapkan template');
        }
    },
};
